<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>





  <mat-dialog-content>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Document Name</mat-label>
        <input
          [(ngModel)]="documentData.name"
          matInput
          #input
        />
       
        <!--  -->
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline">
        <mat-label>Document Description</mat-label>
        <textarea
          [(ngModel)]="documentData.description"
          matInput
        ></textarea>
        <mat-icon matSuffix class="material-icons-outlined">description</mat-icon>
      </mat-form-field>
    </div>
    <div style="display: flex; justify-content: center; align-items: center" *ngIf="!this.editMode">
      <mat-spinner [diameter]="20" *ngIf="loader"></mat-spinner>
    </div>
  
    <!-- <mat-chip-listbox
      style="display: flex; flex-wrap: wrap; width: 400px"
      aria-label="Fish selection"
      class="mb-2"
      *ngIf="!loader && !this.editMode"
    >
      <mat-chip-option
        color="primary"
        selected
        *ngFor="let asset of assetList; let i = index"
        [removable]="removable"
        (removed)="removeAsset(i)"
        style="height: auto"
        >{{ asset?.assetName }}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon></mat-chip-option
      >
    </mat-chip-listbox> -->
    <div *ngFor="let asset of assetList; let i = index" style="display: flex; justify-content: center;">
      <div class="image-preview" style="position: relative;    width: fit-content;    margin-bottom: 20px;    border: 1px solid lightgray;
        padding: 15px;
    ">
        <img [src]="asset.url" alt="" style="width: 300px; height: 170px; object-fit: cover;">

       

        <span (click)="removeAsset(i)" style="position: absolute;
        cursor: pointer;
        top: 0;
        right: 0;
        background: #dd2c00;
        border-radius: 50%;
        height: 30px;
        width: 30px;" ><mat-icon style="    position: absolute;
      left: 3px;
      top: 2px;
      color: white;" class="material-icons-outlined">close</mat-icon></span>
      </div>

    </div>
    <div class="upload-group mb-2" *ngIf="!this.editMode">
      <label for="formFile" class="form-label">Upload document (image files only)</label>
      <div class="file-input-wrap">
        <div class="custom-input-label">
          <mat-icon class="material-icons-outlined" class="mb-1" color="primary"
            >backup</mat-icon
          >
          <p>Drop your file(s) here or <span>browse</span></p>
        </div>
        <input
          class="form-control"
          id="formFile"
          accept="image/*"
          type="file"
          (change)="onUploadImage($event)"
        />
        <!-- multiple -->
      </div>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        !documentData.name ||
        !documentData.description
      "
      (click)="onPost()"
    >
      {{ editMode ? "Edit" : "Confirm" }}
    </button>
  </mat-dialog-actions>
  